import { Checkbox } from "@mui/material";
import * as React from "react";
import { ITodo } from "../../../../../types/interface";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import styled from "styled-components";
export interface ITodoItemProps {
  task: ITodo;
  handledoneTask: (idTask: string, done: boolean) => void;
  startEditTask: (id: string) => void;
  handleDeleteTask: (id: string) => void;
}

export default function TodoItem({
  task,
  handledoneTask,
  startEditTask,
  handleDeleteTask,
}: ITodoItemProps) {
  const onChangeCheckbox =
    (idTask: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      handledoneTask(idTask, event.target.checked);
    };
  return (
    <StyledTaskItem className="p-1 justify-between bg-moodbg flex  border border-bordermood rounded-sm">
      <div className="text-white w-52 flex items-center">
        <span className="task-name">{task?.name}</span>
      </div>
      <div className="flex gap-x-2 items-center">
        <Checkbox
          checked={task ? task.done : false}
          onChange={onChangeCheckbox(task.id)}
        />
        <Tippy content="Edit">
          <i
            onClick={() => startEditTask(task.id)}
            className="bi leading-[0px] text-primary text-lg cursor-pointer bi-pencil-fill"
          ></i>
        </Tippy>

        <Tippy content="Delete">
          <i
            onClick={() => handleDeleteTask(task?.id)}
            className="bi leading-[0px] text-lg text-[#f94144] cursor-pointer bi-trash"
          ></i>
        </Tippy>
      </div>
    </StyledTaskItem>
  );
}
const StyledTaskItem = styled.div`
  .task-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
